export const xArr = [
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z"
]
//标题单元格尺寸
export const tableHeadSize = {
  width: 73.75,
  height: 28
}
//正文单元格尺寸
export const contentSize = {
  width: 73.75,
  height: 28
}
//排序文字单元格尺寸
export const rankSize = {
  width: 25,
  height: 28
}
export const trLength = 10 // 正文最多显示的行数
export const tableWidth = 367.5 //表格宽度
export const colLen = 5
